import { render, staticRenderFns } from "./priceConfiguration.vue?vue&type=template&id=73bc5b0a&scoped=true&"
import script from "./priceConfiguration.vue?vue&type=script&lang=js&"
export * from "./priceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./priceConfiguration.vue?vue&type=style&index=0&id=73bc5b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc5b0a",
  null
  
)

export default component.exports